import { atom } from 'jotai';

import { AnswerSource } from '@cfa/pathway-fe-shared/xp';

export const previewingSourceAtom = atom<{
  source: AnswerSource;
  text: string;
}>();

export const searchFeedbackContextAtom = atom<{
  queryId: string;
}>();
